export default __webpack_public_path__ + "static/media/l13.20a8cbbf.png";